import { useProperty } from '@eti/providers';
import { useEffect } from 'react';
import { bluePush } from './blue';

export const eventTypes = {
  BASKET: 'basket',
  CONVERSION: 'conversion',
  PRODUCT: 'product',
  VISIT: 'visit',
} as const;

type EventTypeValues = (typeof eventTypes)[keyof typeof eventTypes];

export const useGetBlue = (
  eventType: EventTypeValues,
  originAndDestinationCodes?: string,
  totalPriceIncludingAddOnOrders?: number,
) => {
  const { p } = useProperty();
  const isEnabled = p('IbeClient.GetBlue.Enabled');
  const campaignId = p('IbeClient.GetBlue.CampaignId');

  useEffect(() => {
    if (isEnabled && campaignId) {
      const events = [];
      const eventSignature =
        eventType === eventTypes.VISIT ? eventType : `${eventType}|${originAndDestinationCodes}`;

      events.push(
        { event: 'setCampaignId', value: campaignId },
        { event: 'setPageType', value: eventType },
      );

      if (eventType === eventTypes.CONVERSION) {
        events.push(
          { event: 'setProductId', value: originAndDestinationCodes },
          { event: 'setTransactionTotal', value: totalPriceIncludingAddOnOrders },
          { event: 'setTransactionId', value: Math.random() },
        );
      }

      if (eventType === eventTypes.BASKET || eventType === eventTypes.PRODUCT) {
        events.push({ event: 'setProductId', value: originAndDestinationCodes });
      }

      bluePush(eventSignature, events);
    }
  }, [isEnabled, campaignId, eventType, originAndDestinationCodes, totalPriceIncludingAddOnOrders]);
};
